<template>
  <div class="purchase_record">
    <div class="title">
      <i></i>
      <b></b>
      购买记录
    </div>
    <div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane label="CAD户型图" name="1"></el-tab-pane>
        <el-tab-pane label="设计案例" name="2"></el-tab-pane>
        <el-tab-pane label="CAD图库" name="3"></el-tab-pane>
        <el-tab-pane label="高清贴图" name="4"></el-tab-pane>
        <!-- <el-tab-pane label="设计师" name="5"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="s-p">
      <el-date-picker
        v-model="value2"
        type="daterange"
        class="dateTime"
        align="left"
        unlink-panels
        range-separator="至"
        start-placeholder="发布开始日期"
        end-placeholder="发布结束日期"
        value-format="YYYY-MM-DD"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <div class="ml-1">
        <el-button class="btn2" type="primary" @click="getData">查询</el-button>
        <el-button class="btn3" @click="rester">重置</el-button>
      </div>
    </div>
    <div class="t-p">
      <el-table
        class="v-t-table"
        stripe
        height="558px"
        :data="tableData.list"
        v-loading="loading"
        style="width: 100%;overflow-y:scroll"
      >
        <el-table-column type="index" label="序号" align="center" width="150" />
        <el-table-column
          prop="materialCenterName"
          label="素材名称"
          align="center"
        />
        <el-table-column prop="orderNumber" label="订单编号" align="center" />
        <el-table-column
          prop="realityPayMoney"
          label="现金（元）"
          align="center"
        />
        <el-table-column prop="typeName" label="作品类型" align="center" />
        <el-table-column prop="createTime" label="时间" align="center">
          <template slot-scope="scope">
            <span>{{
              $dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="p-p">
      <el-pagination
        class="page"
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :current-page="searchParams.pageNo"
        :total="tableData.total"
        :page-size="searchParams.pageSize"
      />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      value2: [],
      activeName: "0",
      searchParams: {
        createTimeStart: "",
        createTimeEnd: "",
        pageNo: 1,
        pageSize: 10,
        type: 0,
      },
      tableData: [],
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleTabClick() {
      this.searchParams.type = this.activeName;
      this.getData();
    },
    //重置
    rester() {
      this.value2 = [];
      this.searchParams.createTimeStart = "";
      this.searchParams.createTimeEnd = "";
    },
    changePage(page) {
      this.searchParams.pageNo = page;
      this.getData();
    },
    getData() {
      if (this.value2.length > 0) {
        this.searchParams.createTimeStart = this.value2[0];
        this.searchParams.createTimeEnd = this.value2[1];
      }
      const p = {
        userId: sessionStorage.getItem("userId"),
        ...this.searchParams,
      };
      this.loading = true;
      this.$post("order/queryBuyRecord", p).then((res) => {
        this.tableData = res.data;
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="less">
.el-table__body-wrapper::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 0px;
}
</style>
<style lang="less" scoped>
.btn3 {
  margin-left: 8px;
}
.dateTime {
  width: 500px;
}
.purchase_record {
  width: 100%;
  .title {
    display: flex;
    font-size: 22px;
    padding: 0 10px;
    align-items: center;
    line-height: 40px;
    color: #5c80d9;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
    i {
      display: block;
      height: 20px;
      margin-right: 1px;
      border-left: 1px solid #5c80d9;
    }
    b {
      display: block;
      height: 20px;
      margin-right: 8px;
      border-left: 2.5px solid #5c80d9;
    }
    .el-button {
      margin-left: auto;
      margin-right: 8px;
    }
  }
  .s-p {
    display: flex;
    width: 100%;
    height: 50px;
    line-height: 56px;
    align-items: center;
    flex-direction: flex-start;
    padding: 0 10px;
    border-bottom: 1px solid #e5e5e5;
    > * {
      margin-right: 10px;
    }
    .btn {
      margin-left: auto;
    }
  }
  .t-p {
    padding: 12px 10px;
    width: 100%;
    height: calc(100% - 240px);
    overflow-y: auto;
  }
  .p-p {
    display: flex;
    height: 50px;
    justify-content: center;
    // margin-top: 120px;
    align-items: center;
    text-align: center;
  }
}
</style>
